/** Fired after admin saves — public site refreshes without redeploy. */
export const CONTENT_UPDATED_EVENT = 'databiqs-content-updated';

export function notifyContentUpdated(updatedAt) {
  if (typeof window === 'undefined') return;
  const detail = { updatedAt: updatedAt || new Date().toISOString() };
  window.dispatchEvent(new CustomEvent(CONTENT_UPDATED_EVENT, { detail }));
  try {
    const channel = new BroadcastChannel('databiqs-content');
    channel.postMessage(detail);
    channel.close();
  } catch {
    /* BroadcastChannel not supported */
  }
}
